<template>
  <div class="left-right-box" ref="container" :style="{ height: height }">
    <div class="left" :style="{ width: leftWidth + 'px' }" v-if="$slots.left">
      <slot name="left"></slot>
    </div>
    <div
      class="line"
      @mousedown="startDrag"
      :class="{ dragging: isDragging }"
      v-if="$slots.left && $slots.right"
    >
      <div class="drag-handle">
        <svg class="drag-icon" viewBox="0 0 24 24" width="12" height="12">
          <circle cx="12" cy="6" r="1.5" fill="currentColor" />
          <circle cx="12" cy="12" r="1.5" fill="currentColor" />
          <circle cx="12" cy="18" r="1.5" fill="currentColor" />
        </svg>
      </div>
    </div>
    <div class="right" :style="{ width: `calc(100% - ${leftWidth}px - 12px)` }">
      <slot name="right" v-if="$slots.right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftRightBox',
  props: {
    height: {
      type: String,
      default: '100%'
    },
    leftWidthDefault: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      // 页面数据
      leftWidth: 300, // 左侧宽度
      containerWidth: 0, // 容器总宽度
      isDragging: false, // 是否正在拖拽
      startX: 0, // 拖拽开始的X坐标
      startLeftWidth: 0, // 拖拽开始时的左侧宽度

      // 折叠
      isCollapse: false
    }
  },
  computed: {
    // 右侧宽度 = 容器宽度 - 左侧宽度 - 分割线宽度
    rightWidth() {
      return this.getContainerWidth() - this.leftWidth - 4
    }
  },
  created() {
    this.leftWidth = this.leftWidthDefault
  },
  mounted() {
    // 页面初始化逻辑
    // 添加全局鼠标事件监听
    document.addEventListener('mousemove', this.onDrag)
    document.addEventListener('mouseup', this.stopDrag)
    // 监听窗口大小变化
    window.addEventListener('resize', this.initContainer)
  },
  beforeDestroy() {
    // 清理事件监听
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    window.removeEventListener('resize', this.initContainer)
  },
  methods: {
    initContainer() {
      this.containerWidth = this.$refs.container?.offsetWidth
    },
    getContainerWidth() {
      if (this.containerWidth) return this.containerWidth
      this.initContainer()
      return this.containerWidth
    },

    // 开始拖拽
    startDrag(e) {
      this.isDragging = true
      this.startX = e.clientX
      this.startLeftWidth = this.leftWidth
      e.preventDefault()
    },

    // 拖拽中
    onDrag(e) {
      if (!this.isDragging) return

      const deltaX = e.clientX - this.startX
      let newLeftWidth = this.startLeftWidth + deltaX

      // 限制最小和最大宽度
      const minWidth = 100
      const maxWidth = this.getContainerWidth() - 100 - 4 // 减去分割线宽度

      newLeftWidth = Math.max(minWidth, Math.min(maxWidth, newLeftWidth))
      this.leftWidth = newLeftWidth
    },

    // 停止拖拽
    stopDrag() {
      this.isDragging = false
    }
  }
}
</script>

<style scoped lang="less">
.left-right-box {
  color: #000;
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 100%;

  > div {
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }

  .line {
    overflow: hidden;
    width: 6px;
    background: linear-gradient(
      to bottom,
      #f8f9fa 0%,
      #e9ecef 50%,
      #f8f9fa 100%
    );
    cursor: col-resize;
    flex-shrink: 0;
    position: relative;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    margin: 0 3px;

    &:hover {
      background: linear-gradient(
        to bottom,
        #e9ecef 0%,
        #dee2e6 50%,
        #e9ecef 100%
      );
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      .drag-handle {
        background: rgba(108, 117, 125, 0.1);
        transform: scale(1.1);
      }
    }

    &.dragging {
      background: linear-gradient(
        to bottom,
        #dee2e6 0%,
        #adb5bd 50%,
        #dee2e6 100%
      );
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);

      .drag-handle {
        background: rgba(108, 117, 125, 0.2);
        transform: scale(1.2);
      }
    }

    .drag-handle {
      width: 20px;
      height: 30px;
      border-radius: 50%;
      background: rgba(108, 117, 125, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;

      .drag-icon {
        color: #6c757d;
        transition: color 0.2s ease;
      }
    }

    /* 增加拖拽区域 */
    &::before {
      content: '';
      position: absolute;
      left: -4px;
      right: -4px;
      top: 0;
      bottom: 0;
    }
  }

  .left {
    position: relative;
  }
  .right {
    position: relative;
    flex: 1;
  }
}
</style>
